import type { GrowthCategory, GrowthContent } from '@mc/api'
import { Button } from '@mc/design-system'
import { paths } from '@mc/paths'
import type { Subcat } from '../../dataFetching'
import { trackInstructorClick } from '../../events'
import { InstructorImage } from '../InstructorImage'
import classes from '../Browse/Browse.module.scss'

type CourseButtonProps = {
  course: GrowthContent
  category: GrowthCategory
  subcat: Subcat | null
}

export const CourseButton = ({
  course,
  category,
  subcat,
}: CourseButtonProps) => (
  <Button
    as='a'
    key={course.slug}
    kind='tertiary'
    fullWidth
    className={`d-flex mc-p-2 ${classes.categoryBtn}`}
    onClick={() => {
      trackInstructorClick({
        id: course.contentId,
        slug: course.slug,
        type: course.type,
        catName: category.name,
        subcatName: subcat ? subcat.name : null,
      })
    }}
    href={paths.courseTypePage(course.type, course.slug)}
  >
    <InstructorImage
      primary1x1={course.primary1x1 || ''}
      className='mc-mr-2 mc-corners--1'
    />

    <div className='d-flex flex-column'>
      <p className='mc-text--pre-wrap'>
        {truncate(course.instructorName || '')}
      </p>
      <p className='mc-text--pre-wrap mc-text-small mc-text-color--tint'>
        {course.skill}
      </p>
    </div>
  </Button>
)

const truncate = (title: string) => {
  let trunc = title
  const MAX = 70
  while (trunc.length > MAX) {
    trunc = `${trunc.substring(0, trunc.lastIndexOf(' '))}...`
  }
  return trunc
}
